// extracted by mini-css-extract-plugin
export default {"list-item":"IDFPathItem_list-item__5ehwn"};